const RolesEnum = {
  BackOffice: 1,
  Resale: 2,
  Motorista: 3,
  FuncionarioRevenda: 4,
  Cliente: 5,
  Organizacao: 6,
  FuncionarioUpgas: 7
}

export default RolesEnum
